import { action } from 'satcheljs';

export const resetSettingsDialogViewState = action('resetSettingsDialogViewState');

export const resetAllSettingsToDefault = action(
    'resetAllSettingsToDefault',
    (onResetComplete: () => void) => ({
        onResetComplete: onResetComplete,
    })
);
